import { OPENING_CONFIGURATION_TYPE } from 'app/typings/core/admin/experiences/enum/openingConfiguration';
import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import type { PriceConfigurationType } from 'app/typings/core/common/openingConfiguration/priceConfigurationType';
import {
  PRICE_COST_TYPE,
  PRICE_DIFFERENTIATION_MODE,
} from 'app/typings/core/common/openingConfiguration/priceConfigurationType';

const mapToPriceConfiguration = (
  priceConfiguration: PriceConfigurationType | undefined,
  isAlwaysIncludedWithNight: boolean
) => {
  if (!priceConfiguration) {
    return priceConfiguration;
  }

  const expectedMode =
    (isAlwaysIncludedWithNight && PRICE_DIFFERENTIATION_MODE.WITH_DAYTIME) ||
    PRICE_DIFFERENTIATION_MODE.NONE;

  const isConstantType =
    priceConfiguration.type === OPENING_CONFIGURATION_TYPE.CONSTANT;

  const price =
    isConstantType &&
    (isAlwaysIncludedWithNight
      ? priceConfiguration.configuration.daytimePrice
      : priceConfiguration.configuration.price);

  const isFree =
    priceConfiguration.priceDifferentiationMode === expectedMode &&
    isConstantType &&
    price === 0;

  return {
    ...priceConfiguration,
    cost: isFree ? PRICE_COST_TYPE.FREE : PRICE_COST_TYPE.PAID,
  };
};

export const mapExperienceResponseToExperience = (
  response: ExperienceResponse | undefined
): ExperienceResponse | undefined => {
  if (!response) {
    return undefined;
  }

  return {
    ...response,
    openingConfiguration: {
      ...response.openingConfiguration,
      stockConfiguration: response.openingConfiguration?.stockConfiguration,
      priceConfiguration: mapToPriceConfiguration(
        response.openingConfiguration?.priceConfiguration,
        response.isAlwaysIncludedWithNight
      ),
    },
  };
};
